// extracted by mini-css-extract-plugin
module.exports = {"delete":"Icons_delete__1shgJ","list":"Icons_list__39J4R","pro":"Icons_pro__2goHS"};